import { useQuery } from "@tanstack/react-query";
import {
  fetchPublishedEvents,
  fetchAllEvents,
  fetchAllEventsWithCounts,
  fetchSignupSummary,
  fetchSignupsForEvent,
} from "@/lib/events";

export function useEvents() {
  return useQuery({
    queryKey: ["events", "public"],
    queryFn: fetchPublishedEvents,
    staleTime: 60_000,
  });
}

export function useAdminEvents() {
  return useQuery({
    queryKey: ["events", "admin"],
    queryFn: fetchAllEvents,
    staleTime: 30_000,
  });
}

export function useAdminEventsWithCounts() {
  return useQuery({
    queryKey: ["events", "admin", "with-counts"],
    queryFn: fetchAllEventsWithCounts,
    staleTime: 15_000,
  });
}

export function useSignupSummary(eventId: string, enabled: boolean) {
  return useQuery({
    queryKey: ["event-signup-summary", eventId],
    queryFn: () => fetchSignupSummary(eventId),
    enabled,
    staleTime: 30_000,
  });
}

export function useEventSignups(eventId: string | undefined) {
  return useQuery({
    queryKey: ["event-signups", eventId],
    queryFn: () => fetchSignupsForEvent(eventId!),
    enabled: Boolean(eventId),
    staleTime: 10_000,
  });
}
